import { render } from "./SelectLanguage.vue?vue&type=template&id=4e19fdf5&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "./SelectLanguage.vue?vue&type=style&index=0&id=4e19fdf5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e19fdf5"]])

export default __exports__